import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import Popup from "../../../../../../common/components/popup";
import OpenNetworkDomainList from "../components/dbn-global-domains-list";
// import { selectOpennetworkDomainsListItems } from "../../../../../../redux/opennetwork-domains/selector";
import { opennetworkDomains } from "../../../../../../redux/opennetwork-domains/action";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { tenantOpenNetworkDomains } from "../../../../../../redux/dbn-cloud/tenant-open-network-domains/action";
import { selectOpennetworkDomainUpdatedItem, selectTenantOpennetworkDomainsListItems } from "../../../../../../redux/dbn-cloud/tenant-open-network-domains/selector";
import { selectOpennetworkDomainCreatedItem } from "../../../../../../redux/opennetwork-domains/selector";

const DBNDomains = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectTenantOpennetworkDomainsListItems)
  const createItemData = useSelector(selectOpennetworkDomainCreatedItem)
  const updateItemData = useSelector(selectOpennetworkDomainUpdatedItem)
  // const domainsListData = useSelector(selectOpennetworkDomainsListItems)

  const [dbnDomainsList, setDbnDomainsList] = useState<any>([]);
  const [initiallySelectedDomains, setInitiallySelectedDomains] = useState<any>([]);
  const [showOpenNetworkDomainsPopup, setShowOpenNetworkDomainsPopup] = useState<any>(false);

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'Code', headerName: 'Code', searchField: 'Code', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'IsSubDomain', headerName: 'Is SubDomain', searchField: 'IsSubDomain',
        cellRenderer: 'yesNoRenderer',
        filter: true,
        filterType: 'boolean',
      },
      { field: 'ParentDomainName', headerName: 'Parent Domain', searchField: 'ParentDomainName', sortable: true, filter: true, filterType: 'text' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const handleAdd = () => {
    // navigate(`${0}`)
    setShowOpenNetworkDomainsPopup(true)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.EdgeDBNDomainId}`)
  }

  const addSelectedDomains = async (data: any) => {
    dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'create' }))
    await dispatch(tenantOpenNetworkDomains.create({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains`,
      entity: 'openNetworkTaxonomies',
      jsonData: {
        Context: {},
        Records: data
      }
    }))
  }

  const handleDelete = async (data: any) => {
    await dispatch(tenantOpenNetworkDomains.delete({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/delete`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.EdgeDBNDomainId
          }
        ]
      }
    }))

    listDBNDomains();
  }

  const listDBNDomains = async () => {
    await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'list' }))
    await dispatch(tenantOpenNetworkDomains.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "CreatedOnUtc",
        "SortOrder": "desc",
      }
    }))
  }

  const listDBNGlobalDomains = () => {
    dispatch(opennetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(opennetworkDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'dbnGlobalDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null //to get all records 
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
        }
      }
    }))
  }


  useEffect(() => {
    createColumnDefs()
    // listDBNGlobalDomains();
    listDBNDomains()
  }, [pageData, pageSize])

  // useEffect(() => {
  //   setDbnDomainsList(domainsListData?.result?.items)
  // }, [domainsListData]);

  useEffect(() => {
    // if(createItemData?.isSuccess || updateItemData?.isSuccess){
    listDBNDomains();
    // }
  }, [createItemData, updateItemData]);

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Domain</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Publish DBN Domains</title>
          <path d="M17.4776 9.01106C17.485 9.01102 17.4925 9.01101 17.5 9.01101C19.9853 9.01101 22 11.0294 22 13.5193C22 15.8398 20.25 17.7508 18 18M17.4776 9.01106C17.4924 8.84606 17.5 8.67896 17.5 8.51009C17.5 5.46695 15.0376 3 12 3C9.12324 3 6.76233 5.21267 6.52042 8.03192M17.4776 9.01106C17.3753 10.1476 16.9286 11.1846 16.2428 12.0165M6.52042 8.03192C3.98398 8.27373 2 10.4139 2 13.0183C2 15.4417 3.71776 17.4632 6 17.9273M6.52042 8.03192C6.67826 8.01687 6.83823 8.00917 7 8.00917C8.12582 8.00917 9.16474 8.38194 10.0005 9.01101" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 13L12 21M12 13C11.2998 13 9.99153 14.9943 9.5 15.5M12 13C12.7002 13 14.0085 14.9943 14.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlePublishDBNDomains(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    listDBNDomains();
  }

  const handlePublishDBNDomains = async () => {
    await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'publish' }))
    await dispatch(tenantOpenNetworkDomains.publish({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-publish`,
      entity: 'tenantOpenNetworkDomains',
      jsonData:
      {
        Context: {},
        Records: [{}]
      }
    })).then(() => {
      listDBNDomains();
    });
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(tenantOpenNetworkDomains.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (data: any) => {
    // console.log("Item", data)
  }

  const handleSelectAll = (items: any[], checked: any) => {
    // console.log("Items count", checked, items?.length)
    // console.log('items', items)
  }

  const closeModal = () => {
    setShowOpenNetworkDomainsPopup(false)
  }

  const reloadGlobalDomains = async () => {
    listDBNGlobalDomains()
  }

  const handleDBNGlobalDomainsSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(opennetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(opennetworkDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'opennetworkDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null //to get all records 
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
        },
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSubmit = (data: any) => {
    // console.log('Selected domains list:', data)
    addSelectedDomains(data);
    closeModal();
  }

  const LoadOpenNetworkDomainsList = () => {
    return (
      <Popup onClose={closeModal}>
        <OpenNetworkDomainList
          // dbnDomains={dbnDomainsList}
          initiallySelectedDomains={itemsData?.result?.items}
          // paginationData={itemsData?.result?.pagination}
          // handleDBNGlobalDomainsSearch={handleDBNGlobalDomainsSearch}
          // reloadGlobalDomains={reloadGlobalDomains}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        />
      </Popup>
    )
  }

  return (
    <>
      {showOpenNetworkDomainsPopup ? <LoadOpenNetworkDomainsList /> : <></>}
      {itemsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          onSelect={handleSelect}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Name',
          }}
          additionButtons={additionButtons}
          headingName="ONE Taxonomy Domains"
        />
      }
    </>
  );
};

export default DBNDomains;
